import { oofEnums } from '@vectronic/openApi-customer';

export type PaymentMethodProperties = {
  label: string;
  icon: string;
};

export const paymentMethods: Record<oofEnums.PaymentMethod, PaymentMethodProperties> = {
  credit_card: { label: 'Credit card', icon: 'credit_card' },
  bank_wire_transfer: { label: 'Bank wire transfer', icon: 'account_balance' },
  check: { label: 'Check', icon: 'payments' },
  purchase_order: {
    label: 'Purchase order / delivery order',
    icon: 'receipt_long',
  },
} as const;

export const allPaymentMethods = Object.entries(paymentMethods).map(([key, props]) => ({
  key,
  props,
}));
